import { useFeatureFlag } from 'context/FeatureFlagProvider/FeatureFlagProvider';
import { FEATURE_FLAGS_LIST } from 'lib/featureFlagsList';
import { DashboardPage } from 'pages/DashboardPage';
import { OrganizationViewPage } from 'pages/OrganizationViewPage';
import { type FC, type ReactNode, useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';

const DashboardFeatureFlagWrapper: FC = () => {
  const { hasFeatureFlagPermission, isInitialLoadComplete } = useFeatureFlag();
  const [Component, setComponent] = useState<ReactNode>(null);

  useEffect(() => {
    if (isInitialLoadComplete) {
      const showOrganizationView = hasFeatureFlagPermission(
        FEATURE_FLAGS_LIST.organizationSummary.get
      );
      setComponent(
        showOrganizationView ? <OrganizationViewPage /> : <DashboardPage />
      );
    }
  }, [isInitialLoadComplete, hasFeatureFlagPermission]);

  if (!Component) {
    return (
      <div className="flex flex-col gap-6">
        <div className="flex flex-1 w-full gap-6">
          <Skeleton containerClassName="w-8/12" height={400} />{' '}
          <Skeleton height={400} containerClassName="w-4/12" />
        </div>
        <Skeleton height={300} />
      </div>
    );
  }

  return <>{Component}</>;
};
export default DashboardFeatureFlagWrapper;
